import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import axios from 'axios';
import { API_BASE } from './api';

let registered = false;

export async function registerForFcmPush() {
  if (!Capacitor.isNativePlatform()) return;
  if (registered) return;

  let perm;
  try {
    perm = await PushNotifications.checkPermissions();
  } catch (e) {
    console.warn('PushNotifications.checkPermissions failed:', e);
    return;
  }

  let status = perm.receive;
  if (status === 'prompt' || status === 'prompt-with-rationale') {
    try {
      const req = await PushNotifications.requestPermissions();
      status = req.receive;
    } catch (e) {
      console.warn('PushNotifications.requestPermissions failed:', e);
      return;
    }
  }
  if (status !== 'granted') {
    console.warn('Push notification permission not granted:', status);
    return;
  }

  // Latch the flag on attempt, not on POST success.
  // Backend deduplicates on (user_id, fcm_token) so a duplicate POST is harmless,
  // but Capacitor addListener does NOT deduplicate, so we must never add listeners twice.
  registered = true;

  // Register listeners BEFORE calling register() to avoid missing events
  PushNotifications.addListener('registration', async (token) => {
    try {
      await axios.post(`${API_BASE}/push/subscribe`, { fcm_token: token.value, type: 'fcm' });
      console.log('FCM token registered with backend');
    } catch (e) {
      console.error('Failed to register FCM token with backend:', e);
    }
  });

  PushNotifications.addListener('registrationError', (err) => {
    console.error('FCM registration error:', err);
  });

  PushNotifications.addListener('pushNotificationReceived', (notification) => {
    console.log('Push received in foreground:', notification);
  });

  PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
    console.log('Push action performed:', action);
  });

  try {
    await PushNotifications.register();
  } catch (e) {
    console.error('PushNotifications.register failed:', e);
  }
}
